import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { EnrichedIncident } from '../models/incident.model';

@Injectable({
  providedIn: 'root'
})
export class IncidentDataService {
  private incidentDataSubject = new BehaviorSubject<EnrichedIncident | null>(null);
  public incidentData$: Observable<EnrichedIncident | null> = this.incidentDataSubject.asObservable();

  setIncidentData(incident: EnrichedIncident | null): void {
    this.incidentDataSubject.next(incident);
  }

  getIncidentData(): EnrichedIncident | null {
    return this.incidentDataSubject.value;
  }

  clearIncidentData(): void {
    this.incidentDataSubject.next(null);
  }
}
